export const ROUTES_VARIANT = {
  VERIFY_OTP: "verifyOTP",
  FINISH: "finish",
  PROCESS: "process",
};
